module.exports = __webpack_public_path__ + "static/media/checkboxAnswer.ae79cb1e.svg";